











 











const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamsLimitExceededNotification_notification",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationTemplate_notification"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgPicture",
      "storageKey": null
    }
  ],
  "type": "NotifyTeamsLimitExceeded",
  "abstractKey": null
};

(node ).hash = "dc90ac1eecd2c2db99fa30a2303e2b1c";

export default node;
